import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Select, Label } from '@ipc/ipc-components';
import { getUserRole } from '../../../../common/user/redux/selectors/UserSelectors';
import { getContactGroup } from '../redux/selectors/MrdContactsSelectors';
import { setContactGroupActionCreator } from '../redux/actions/ContactsActions';
// eslint-disable-next-line import/no-cycle
import ListTableContainer from '../../../../common/list-table/containers/ListTableContainer';
import { MrdContactsStyles } from '../component/MrdContacts.styles';

function MrdContactsManagementContainer(props) {
  const {
    userRole,
    selectedContactGroup,
    updateContactGroup,
  } = props;

  const [selectedContactTable, updateSelectedContactTable] = useState(userRole.includes('IPC') ? 'IPC' : 'MRD');

  const options = [
    { label: 'IPC Contacts', value: 'IPC' },
    { label: 'MRD Contacts', value: 'MRD' },
    { label: 'Data Sharing', value: 'DATA_SHARING' },
  ];

  const mrdOptions = [
    { label: 'MRD Contacts', value: 'MRD' },
  ];

  useEffect(() => {
    if (selectedContactGroup && selectedContactTable !== selectedContactGroup) {
      updateSelectedContactTable(selectedContactGroup);
      updateContactGroup(null);
    }
  }, [selectedContactGroup]);

  const handleChangeContactType = (option) => {
    updateSelectedContactTable(option.value);
    return null;
  };
  return (
    <MrdContactsStyles>
      <div className="mrd-contacts-container">
        <div className="contact-group-type">
          <table>
            <tbody>
              <tr>
                <td className="form-input-fields"><Label>CONTACT GROUP TYPE</Label></td>
                <td className="form-input-fields">
                  <Select
                    value={selectedContactTable}
                    placeholder={options.find((item) => item.value === selectedContactTable).label}
                    options={userRole.includes('IPC') ? options : mrdOptions}
                    onChange={handleChangeContactType}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {selectedContactTable === 'IPC' && (
          <ListTableContainer tableId="IPC_CONTACTS" />
        )}
        {selectedContactTable === 'MRD' && (
          <ListTableContainer tableId="MRD_CONTACTS" />
        )}
        {selectedContactTable === 'DATA_SHARING' && (
          <ListTableContainer tableId="XML_CONTACTS" />
        )}
      </div>
    </MrdContactsStyles>
  );
}

function mapStateToProps(state) {
  return {
    userRole: getUserRole(state),
    selectedContactGroup: getContactGroup(state),
  };
}
const mapDispatchToProps = (dispatch) => bindActionCreators({
  updateContactGroup: setContactGroupActionCreator,
}, dispatch);

MrdContactsManagementContainer.propTypes = {
  userRole: PropTypes.string,
  selectedContactGroup: PropTypes.string,
  updateContactGroup: PropTypes.func,
};
export default connect(mapStateToProps, mapDispatchToProps)(MrdContactsManagementContainer);
